module.exports = __webpack_public_path__ + "img/468.843d35bc.png";